<template>
  <BaseAutoCompleteWithSingleSelectedItem
    v-model="selectedItem"
    :label="i18n.global.t('pages.vehicles.form.digitacoMapping')"
    itemName="name"
    :items="items"
    :operation-offices="
      operationOffice === undefined ? undefined : [operationOffice]
    "
    :error-messages="errorMessages"
    :readonly="props.readonly"
    :disabled="props.disabled"
    :clearable="!props.readonly"
  />
</template>
<script setup lang="ts">
import BaseAutoCompleteWithSingleSelectedItem from '@/components/AutoCompletes/BaseAutoCompleteWithSingleSelectedItem.vue';
import Api from '@/services/api/ApiServiceFabrick';
import getOperationOffice from '@/types/responses/getOperationOffice';
import { onMounted, ref, watch } from 'vue';
import i18n from '@/lang/i18n';

const props = withDefaults(
  defineProps<{
    modelValue: ItemType | undefined;
    initialItemId?: number;
    operationOffice?: getOperationOffice | undefined;
    errorMessages?: string[];
    readonly?: boolean;
    disabled?: boolean;
  }>(),
  {
    readonly: false,
    disabled: false,
  }
)

const emit = defineEmits(['update:modelValue']);

type ItemType = {
  id: number;
  name: string;
  operationOfficeId: number;
  device_id: string;
  imei: string;
  model_type?: number;
};

const selectedItem = ref<ItemType | undefined>(undefined);
const items = ref<ItemType[]>([]);

onMounted(async () => {
  await getItems();
  selectedItem.value = items.value.find(
    (item) => item.id === props.initialItemId
  );
});

// operationOfficeが変更された時にitemsを更新する
watch(
  () => props.operationOffice,
  () => {
    getItems();
  }
);

// initialItemIdが変更された時にselectedItemを更新する
watch(
  () => props.initialItemId,
  () => {
    selectedItem.value = items.value.find(
      (item) => item.id === props.initialItemId
    );
  }
);

// selectedItemがitemsに含まれていない場合は選択を解除する
watch(
  () => items.value,
  () => {
    selectedItem.value = items.value.find(
      (item) => item.id === selectedItem.value?.id
    );
  }
);

// 変更を親コンポーネントに伝える
watch(
  () => selectedItem.value,
  (newValue) => {
    emit('update:modelValue', newValue);
  }
);

const getItems = async () => {
  if (!props.operationOffice) {
    items.value = [];
    return;
  }

  const params = {
    status: 'all',
    operation_office_id: props.operationOffice.id,
  };
  const devices = await Api().autoComplete.devices(params)

  const _devices = devices.filter((device) => {
    if (device.id == props.initialItemId) {
      return true;
    }
    return !device.vehicle_id;
  });
  const itemTmp: ItemType[] = [];
  const itemIds: number[] = [];
  _devices.forEach((v) => {
    const item = { ...v };
    if (item && !itemIds.includes(item?.id)) {
      itemTmp.push({
        id: v.id,
        name: v.device_id,
        operationOfficeId: v.operation_office_id,
        device_id: v.device_id,
        imei: v.imei,
        model_type: v.model_type ?? undefined,
      });
      itemIds.push(item.id);
    }
  });
  items.value = itemTmp;
};
</script>
